import { createReducer, on, Action } from '@ngrx/store';
import { Details } from '@details/Interfaces/details';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as Actions from '../actions/additional-information.actions';
import { UdfGroup } from '@feature/_app_modules/additional-information/models/UdfGroups';

export class AdditionalInformationInstance {
  id: number;
  details?: Details;
  userSelectedGroups?: UdfGroup[];
  loading: boolean;
}

export const adapter: EntityAdapter<AdditionalInformationInstance> = createEntityAdapter<AdditionalInformationInstance>();

export interface State extends EntityState<AdditionalInformationInstance>{};

export const initialState: State = adapter.getInitialState();

const additionalInformationReducer = createReducer(
  initialState,

  on(Actions.loadUserSelectedGroups, (state, { dashboardWidgetId }) => {
    const instance: AdditionalInformationInstance =
      { id: dashboardWidgetId, loading: true, userSelectedGroups: undefined, details: undefined };
    return adapter.upsertOne(instance, state);
  }),

  on(Actions.loadUserSelectedGroupsComplete, (state, { dashboardWidgetId, userSelectedGroups }) => {
    const instance: AdditionalInformationInstance = { id: dashboardWidgetId, loading: false, userSelectedGroups };
    return adapter.upsertOne(instance, state);
  }),

  on(Actions.loadDetails, (state, { dashboardWidgetId }) => {
    const instance: AdditionalInformationInstance = { id: dashboardWidgetId, loading: true, details: undefined, userSelectedGroups: undefined };
    return adapter.upsertOne(instance, state);
  }),

  on(Actions.loadDetailsComplete, (state, { dashboardWidgetId, details }) => {
    const instance: AdditionalInformationInstance = { id: dashboardWidgetId, loading: false, details };
    return adapter.upsertOne(instance, state);
  })
);

export function reducer(state: State | undefined, action: Action) {
  return additionalInformationReducer(state, action);
}
